import useFetchWDACCatalogInventory from './useFetchWDACCatalogInventory';
import WdacCatalogInventoryTable from './WdacCatalogInventoryTable';

const WdacCatalogInventory = () => {
  const {
    isLoading,
    data: catalogInventoryList,
    lastElementRef,
    isFetching,
    count,
    unsignedCount,
    query,
  } = useFetchWDACCatalogInventory();

  return (
    <WdacCatalogInventoryTable
      isLoading={isLoading}
      isFetching={isFetching}
      catalogInventoryList={catalogInventoryList}
      lastElementRef={lastElementRef}
      totalCount={count}
      unsignedCount={unsignedCount}
      query={query}
    />
  );
};

export default WdacCatalogInventory;
